import React, { Component } from "react";
import PropTypes from "prop-types";
import { Sort } from "../../lib/icons";
import { gatherClasses } from "../../lib/utils";

// eslint-disable-next-line react/prefer-stateless-function
class SortIndicator extends Component {
  render() {
    const { alt, sortBy, sortDirection, columnName, disabled } = this.props;
    const isAsc = sortDirection === "ASC" ? Boolean(true) : false;
    if (sortBy !== columnName) {
      return (
        <div
          className={gatherClasses(
            null,
            "oui-icn-container",
            disabled && "oui-disabled"
          )}
        >
          <img
            draggable={false}
            alt={alt}
            src={Sort}
            className={gatherClasses(
              this.props,
              "oui-icn",
              "oui-icn-sort",
              disabled ? "oui-icn-disabled" : "oui-icn-inactive",
              "oui-icn-sort--down"
            )}
            style={{ marginRight: "2px" }}
          />
          <img
            draggable={false}
            alt={alt}
            src={Sort}
            className={gatherClasses(
              this.props,
              "oui-icn",
              "oui-icn-sort",
              disabled ? "oui-icn-disabled" : "oui-icn-inactive",
              "oui-icn-sort--up"
            )}
          />
        </div>
      );
    }
    return (
      <div
        className={gatherClasses(
          null,
          "oui-icn-container",
          disabled && "oui-disabled"
        )}
      >
        <img
          draggable={false}
          alt={alt}
          src={Sort}
          className={gatherClasses(
            this.props,
            "oui-icn",
            "oui-icn-sort",
            "oui-icn-sort--down",
            isAsc ? "oui-icn-sort--up" : "oui-icn-sort--down",
            disabled && "oui-icn-disabled"
          )}
        />
      </div>
    );
  }
}

SortIndicator.propTypes = {
  sortDirection: PropTypes.oneOf(["ASC", "DESC"]),
  sortBy: PropTypes.string.isRequired,
  columnName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  alt: PropTypes.string
};

SortIndicator.defaultProps = {
  sortDirection: "DESC",
  alt: "Sort Icon"
};

SortIndicator.displayName = "OrionSortIndicator";

export default SortIndicator;
